<template>
    <div v-if="isLoading" class="spinner-container" :style="style">
        <double-bounce background="#F5C51E"></double-bounce>
    </div>
</template>

<script>

import { DoubleBounce } from 'vue-loading-spinner';
export default {
    components: { DoubleBounce },

    props: {
        fullscreen: {
            type: Boolean,
            required: false,
            default: false
        },
        fullParent: {
            type: Boolean,
            required: false,
            default: true
        },
        height: {
            type: Number,
            required: false,
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        clearBackground: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        style() {
            var style = {
                position: this.fullscreen ? 'fixed' : (this.fullParent ? 'absolute' : 'relative')
            };
            if (this.height) {
                style.height = this.height;
            }
            if (this.clearBackground) {
                style.background = 'transparent';
            }
            return style;
        }
    }
}
</script>

<style scoped>
    .spinner-container {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 3000;
        background: rgba(0, 0, 0, 0.4);
    }
</style>
